// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2V6IP","button":"style_button__19o2f","selected":"style_selected__3_KJZ"};